import JobDetails from '@/views/common/JobDetails';
import JobView from '@/views/common/JobDetails/View';
import JobEdit from '@/views/employer/JobDetails/Edit';
import JobNew from '@/views/employer/JobDetails/New';
import MyJobs from '@/views/employer/MyJobs';


export default [
  {
    path: '/jobs/new',
    name: 'job-new',
    component: JobNew,
  }, {
    path: '/my-jobs',
    name: 'my-jobs',
    component: MyJobs,
  }, {
    path: '/jobs/:id',
    component: JobDetails,
    meta: { requiresAuth: false },

    children: [
      {
        path: '',
        component: JobView,
        name: 'job-view',
      },
      {
        path: 'edit',
        meta: { onlyEmployer: true },
        component: JobEdit,
        name: 'job-edit',
      },
    ],
  },
];
